import objectAssign from "object-assign";
import actionTypes from "actionTypes";

const initialState = {
  isLoading: false,
  layoutClassName: "",
  secondaryHeader: {
    isVisible: true,
  },
  backendErrorMessage: "",
  currentTenant: {},
};

export default function common(state, action) {
  if (typeof state === "undefined") {
    return initialState;
  }

  let newState = null;

  switch (action.type) {
    case "SET_LOADING":
      newState = objectAssign({}, state);
      newState.isLoading = action.loading;
      return newState;
    case "SET_SECONDARY_HEADER":
      return {
        ...state,
        secondaryHeader: {
          ...action.payload,
        },
      };
    case actionTypes.SET_BACKEND_ERROR_MESSAGE:
      newState = objectAssign({}, state, {
        backendErrorMessage: action.errorMessage,
      });
      return newState;
    case actionTypes.SET_CURRENT_TENANT:
      newState = objectAssign({}, state, {
        currentTenant: {
          ...action.payload,
        },
      });
      return newState;
  }
  return state;
}
